import {join} from '@esgi/ui-kit/utils';
import {useCallback, ChangeEvent, FocusEvent} from 'react';
import {TextArea as BaseTextArea, TextAreaProps} from '@esgi/ui-kit/control';
import {ElementStatus, useFormElementContext} from '@esgi/ui-kit/form';
import styles from './text-area.module.less';

type Props = Omit<TextAreaProps, 'value' | 'onChange' | 'disabled'>;

export function TextArea(props: Props): JSX.Element {
	const {setRef, setValue, status, value, validateOnBlur} = useFormElementContext({string: true}, TextArea);
	const onChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => setValue(e.target.value), [setValue]);
	const onBlur = useCallback((e: FocusEvent<HTMLTextAreaElement, Element>) => {
		validateOnBlur();
		props.onBlur?.(e);
	}, [validateOnBlur]);
	const ref = useCallback((r: any) => setRef(r?.inputRef.current), [setRef]);

	const className = join(
		status === ElementStatus.invalid && styles.error,
		status === ElementStatus.valid && styles.success,
		props.className,
	);

	return <BaseTextArea {...props}
	                     className={className}
	                     value={value}
	                     ref={ref}
	                     onChange={onChange}
	                     onBlur={onBlur}
	                     aria-invalid={status === ElementStatus.invalid}
	                     disabled={status === ElementStatus.disabled}/>;
}
